/*
    Collection point for messages strings / other used throughout the application
 */
// skills
const SKILL_ADD_SUCCESS = "Skill creation was successful!";
const SKILL_ADD_ERROR = "Skill creation not successful!";
const SKILL_EDIT_SUCCESS = "Skill edit was successful!";
const SKILL_EDIT_ERROR = "Skill edit not successful!";

// user profile
const USER_PROFILE_UPDATE_SUCCESS = "User profile update was successful!"
const USER_PROFILE_UPDATE_ERROR = "User profile update was not successful!"

const USER_ACK_UPDATE_SUCCESS = "User ack update was successful!"
const USER_ACK_UPDATE_ERROR = "User ack update was successful!"

// education
const EDUCATION_ADD_SUCCESS = "Education creation was successful!";
const EDUCATION_ADD_ERROR = "Education creation not successful!";
const EDUCATION_EDIT_SUCCESS = "Education edit was successful!";
const EDUCATION_EDIT_ERROR = "Education edit not successful!";

// certs
const CERT_ADD_SUCCESS = "Certification creation was successful!";
const CERT_ADD_ERROR = "Certification creation not successful!";
const CERT_EDIT_SUCCESS = "Certification edit was successful!";
const CERT_EDIT_ERROR = "Certification edit not successful!";
const CERT_MERGE_SUCCESS = "Certification merge was successful!";
const CERT_MERGE_ERROR = "Certification merge not successful!";


// exp
const EXPERIENCE_ADD_SUCCESS = "Experience creation was successful!";
const EXPERIENCE_ADD_ERROR = "Experience creation not successful!";
const EXPERIENCE_EDIT_SUCCESS = "Experience edit was successful!";
const EXPERIENCE_EDIT_ERROR = "Experience edit not successful!";

// project
const PROJECT_ADD_SUCCESS = "Experience creation was successful!";
const PROJECT_ADD_ERROR = "Experience creation not successful!";
const PROJECT_EDIT_SUCCESS = "Experience edit was successful!";
const PROJECT_EDIT_ERROR = "Experience edit not successful!";

// admin
const USER_ADD_SUCCESS = "User creation was successful!";
const USER_ADD_ERROR = "User creation was not successful!";
const USER_EDIT_SUCCESS = "User edit was successful!";
const USER_EDIT_ERROR = "User edit was not successful!";

const SKILL_TYPE_ADD_SUCCESS = "Skill creation was successful!";
const SKILL_TYPE_ADD_ERROR = "Skill creation not successful!";
const SKILL_TYPE_EDIT_SUCCESS = "Skill edit was successful!";
const SKILL_TYPE_EDIT_ERROR = "Skill edit not successful!";

export {
    SKILL_ADD_SUCCESS,
    SKILL_ADD_ERROR,
    SKILL_EDIT_SUCCESS,
    SKILL_EDIT_ERROR,
    USER_PROFILE_UPDATE_SUCCESS,
    USER_PROFILE_UPDATE_ERROR,
    USER_ACK_UPDATE_SUCCESS,
    USER_ACK_UPDATE_ERROR,
    EDUCATION_ADD_ERROR,
    EDUCATION_EDIT_ERROR,
    EDUCATION_EDIT_SUCCESS,
    EDUCATION_ADD_SUCCESS,
    CERT_ADD_ERROR,
    CERT_ADD_SUCCESS,
    CERT_EDIT_ERROR,
    CERT_EDIT_SUCCESS,
    CERT_MERGE_SUCCESS,
    CERT_MERGE_ERROR,
    EXPERIENCE_ADD_ERROR,
    EXPERIENCE_EDIT_ERROR,
    EXPERIENCE_EDIT_SUCCESS,
    EXPERIENCE_ADD_SUCCESS,
    PROJECT_EDIT_ERROR,
    PROJECT_EDIT_SUCCESS,
    PROJECT_ADD_ERROR,
    PROJECT_ADD_SUCCESS,
    USER_ADD_SUCCESS,
    USER_ADD_ERROR,
    USER_EDIT_ERROR,
    USER_EDIT_SUCCESS,
    SKILL_TYPE_ADD_SUCCESS,
    SKILL_TYPE_EDIT_ERROR,
    SKILL_TYPE_ADD_ERROR,
    SKILL_TYPE_EDIT_SUCCESS,
};